import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Portfolio from "./pages/portfolio";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function App() {
  useEffect(() => {
    // Force dark mode globally
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="*" element={<Portfolio />} />
      </Routes>
    </>
  );
}

export default App;
